<template>
  <div class="app-container">
    <div class="flex">
      <div class="flex-left">
        <BjInput v-model="filterText" :placeholder="$t('goodsClassify.page.SearchCategory')" style="width:90%;"> </BjInput>
        <h3 class="pointer" @click="handleNodeClick()">{{ $t('goodsClassify.page.AllCategories') }}</h3>
        <div class="tree-box">
          <el-tree ref="tree" :data="treeData" :props="defaultProps" :filter-node-method="filterNode" :expand-on-click-node="false" @node-click="handleNodeClick" />
        </div>
      </div>
      <div class="flex-right">
        <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'120px'" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="reFreshLeftTree" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
          <template v-slot:baseForm>
            <el-col :span="colSpan">
              <el-form-item :label="$t('goodsClassify.common.ClassificationName')" prop="name">
                <BjInput v-model="queryParams.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('goodsClassify.common.ClassificationCode')" prop="code">
                <BjInput v-model="queryParams.code" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('goodsClassify.page.CategoryType')" prop="subFlag">
                <BjSelectLov v-model="queryParams.subFlag" :option-list="GOODS_CLASSIFY_TYPES" :placeholder="$t('chooseText')" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('goodsClassify.page.ParentClass')" prop="parentId">
                <BjGoodsTypeTreeSelect ref="BjGoodsTypeTreeSelect" v-model="queryParams.parentId" />
              </el-form-item>
            </el-col>
          </template>
          <template v-slot:tableOperation="tableOperationProp">
            <el-col>
              <el-button v-permission:BusinessGoodsClassify_Delete type="primary" :disabled="tableOperationProp.notSelected" class="delete-btn" @click="onDeleteSelected">{{ $t('delText') }}</el-button>
              <!-- <el-button v-permission:BusinessGoodsClassify_DownloadTemplate type="primary" @click="onDownload">{{ $t('downloadTemplateText') }}</el-button>
              <el-button v-permission:BusinessGoodsClassify_ImportData type="primary" @click="onLead">{{ $t('importDataText') }}</el-button> -->
              <el-button v-permission:BusinessGoodsClassify_Add type="primary" class="main-btn" @click="onAdd">{{ $t('goodsClassify.page.AddCategory') }}</el-button>
            </el-col>
          </template>
          <template v-slot:tableColumn>
            <template v-for="(col, index) in dropCols">
              <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                <template slot-scope="scope">
                  <template v-if="false" />
                  <el-tag v-else-if="col.prop === 'statusFlag'" :type="scope.row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row[col.prop])) }}</el-tag>
                  <span v-else-if="col.prop === 'subFlag'">{{ $t(GOODS_CLASSIFY_TYPES.bjGet(scope.row[col.prop])) }}
                  </span>
                  <span v-else-if="col.prop === 'attributeList'">
                    {{ scope.row.attributeList.length }}
                  </span>
                  <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                <template slot-scope="scope">
                  <el-button v-permission:BusinessGoodsClassify_Edit type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
                  <el-button v-if="!scope.row.statusFlag" v-permission:BusinessGoodsClassify_Status type="text" @click="onStatus(true, scope.row)">{{ $t('enableText') }}</el-button>
                  <el-button v-if="scope.row.statusFlag" v-permission:BusinessGoodsClassify_Status type="text" @click="onStatus(false, scope.row)">{{ $t('disableText') }}</el-button>
                  <el-button v-permission:BusinessGoodsClassify_Delete :disabled="scope.row.hasSubOrSPUFlag || scope.row.statusFlag == true" type="text" class="delete-btn" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </BjPage>
      </div>
    </div>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFreshData" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { goodsApi } from '@/api';
import DataForm from './components/DataForm.vue';
import { GOODS_CLASSIFY_TYPES, STATUS_ENABLED_TRUE } from '@/utils/constants';

export default {
  name: 'BusinessGoodsClassifyIndex',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 8,
      GOODS_CLASSIFY_TYPES,
      STATUS_ENABLED_TRUE,
      queryApi: goodsApi.getPageCategory,
      // 查询参数
      queryParams: {
        name: null,
        code: null,
        subFlag: null,
        parentId: null,
      },
      labelsVersion: 11,
      labelList: [
        { label: 'goodsClassify.table.ClassificationName', prop: 'name', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsClassify.table.ClassificationCode', prop: 'code', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsClassify.table.ParentClass', prop: 'parentName', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsClassify.table.Type', prop: 'subFlag', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsClassify.table.bindingAttributes', prop: 'attributeList', isCheck: true, disabled: false, width: 190 },
        { label: 'goodsClassify.table.Remarks', prop: 'remark', isCheck: true, disabled: false, width: 200 },
        { label: 'table.statusText', prop: 'statusFlag', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
      ],
      /** * 左侧树 */
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      treeData: [],
      filterText: '',
      names: this.$t('goodsClassify.page.AllCategories'),
    };
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted() {
    this.reFreshLeftTree();
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    reFreshLeftTree() {
      this.queryParams.parentId = null;
      this.names = this.$t('goodsClassify.page.AllCategories');
      this.filterText = null;
      goodsApi.getAllCategory().then(res => {
        // 更新分类组件
        this.$refs.BjGoodsTypeTreeSelect.getData();
        this.treeData = (res || []).map(e => {
          if (!e.children) {
            delete e.children;
          }
          if (e.children && !e.children.length) {
            delete e.children;
          }
          return e;
        });
      });

      return new Promise(resolve => {
        resolve();
      });
    },
    /**
     * 单击选中：右侧表格显示该公司的所有下属公司
     */
    handleNodeClick(data, node) {
      const names = [];
      while (node) {
        if (node.data.name) names.push(node.data.name);
        node = node.parent;
      }
      names.reverse();
      this.names = names.join(' > ') || this.$t('goodsClassify.page.AllCategories');

      this.queryParams.parentId = data ? data.id : null;
      this.reFresh();
    },

    onDownload() {},
    onLead() {},
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = flag ? this.$t('enableText') : this.$t('disableText');
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
      })
      .then(() => {
        this.operationApi({
          id: row.id,
          statusFlag: flag,
          objectVersionNumber: row.objectVersionNumber,
        });
      });
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')}  ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
      .then(() => {
        this.batchDeleteApi([row.id]);
      });
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      //   :disabled="scope.row.hasSubOrSPUFlag || scope.row.statusFlag == true"
      if (this.selectedRows.some(e => e.statusFlag)) {
        this.$message.warning(this.$t('toast.delEnabledTipText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi(ids);
        })
        .catch(() => {});
    },
    /** 添加 */
    onAddChild(row) {
      this.$refs.DataForm.show();
      this.$refs.DataForm.setParentId(row.id);
    },
    /** 新建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },
    /* 关闭弹窗 */
    handleClose() {
      this.dialogVisible = false;
    },
    operationApi(API_DATA) {
      goodsApi.operationCategory(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));

          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      goodsApi.batchDeleteCategory(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFreshData();
          }, 500);
        }
      });
    },
    reFreshData() {
      this.reFresh();
      this.reFreshLeftTree();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.flex {
  flex-wrap: nowrap;
  .flex-left {
    width: 300px;
    height: 100%;
    overflow: auto;
  }
  .flex-right {
    width: calc(100% - 300px);
  }
}
.tree-box {
  overflow: auto;
  min-height: 100%;
  height: calc(100vh - 265px);
  margin-right: 30px;
}
.org-name {
  margin: 0;
  margin-top: 6px;
  color: #606266;
  font-size: 14px;
}
</style>
